import React from 'react';
import Icon from '@Theme/natucare/components/Icon/Icon';
import { radioIconPropTypes } from './RadioIconPropTypes';
import * as styles from './RadioIcon.module.scss';
const RadioIcon = ({
  label,
  name,
  id,
  value,
  icon
}) => {
  if (!label && !icon && !name) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("input", {
    id: id,
    value: value,
    name: name,
    className: `${styles.rootInput}`,
    type: "radio"
  }), /*#__PURE__*/React.createElement("label", {
    className: styles.rootLabel,
    htmlFor: name
  }, label), icon && /*#__PURE__*/React.createElement("span", {
    className: styles.rootIconWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    name: icon,
    classname: styles.rootIcon
  })));
};
export default RadioIcon;